interface SectionHeaderProps {
    number: number;
    title: string;
}

export const SectionHeader = ({ number, title }: SectionHeaderProps) => (
    <div className='flex items-center gap-3'>
        <div className='bg-neutral-subtle flex size-8 items-center justify-center rounded-full'>
            <span className='text-label-sm-bold text-dark'>{number}</span>
        </div>
        <span className='text-heading-h4 text-dark'>{title}</span>
    </div>
);
